import React from 'react';

class SpeakerIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_254_1450)">
          <g filter="url(#filter0_d_254_1450)">
            <path
              d="M56 4H24C20.6863 4 18 6.68629 18 10V70C18 73.3137 20.6863 76 24 76H56C59.3137 76 62 73.3137 62 70V10C62 6.68629 59.3137 4 56 4Z"
              fill="#F7F4F1"
            />
            <path
              d="M56.0002 76.7999H24.0002C20.2502 76.7999 17.2002 73.75 17.2002 70V9.99995C17.2002 6.24995 20.2502 3.19995 24.0002 3.19995H56.0002C59.7502 3.19995 62.8002 6.24995 62.8002 9.99995V70C62.8002 73.75 59.7502 76.7999 56.0002 76.7999ZM24.0002 4.79995C21.1322 4.79995 18.8002 7.13195 18.8002 9.99995V70C18.8002 72.868 21.1322 75.2 24.0002 75.2H56.0002C58.8682 75.2 61.2002 72.868 61.2002 70V9.99995C61.2002 7.13195 58.8682 4.79995 56.0002 4.79995H24.0002Z"
              fill="#84827E"
            />
            <path
              d="M40 40.8999C32.268 40.8999 26 47.1679 26 54.8999C26 62.6319 32.268 68.8999 40 68.8999C47.732 68.8999 54 62.6319 54 54.8999C54 47.1679 47.732 40.8999 40 40.8999Z"
              fill="url(#paint0_linear_254_1450)"
            />
            <path
              d="M40 13.0999C33.924 13.0999 29 18.0239 29 24.0999C29 30.1759 33.924 35.0999 40 35.0999C46.076 35.0999 51 30.1759 51 24.0999C51 18.0239 46.076 13.0999 40 13.0999Z"
              fill="url(#paint1_linear_254_1450)"
            />
            <path
              d="M40.0006 64.3C45.1921 64.3 49.4006 60.0915 49.4006 54.9C49.4006 49.7085 45.1921 45.5 40.0006 45.5C34.8091 45.5 30.6006 49.7085 30.6006 54.9C30.6006 60.0915 34.8091 64.3 40.0006 64.3Z"
              fill="white"
            />
            <path
              d="M39.9998 30.2999C43.424 30.2999 46.1998 27.5241 46.1998 24.0999C46.1998 20.6757 43.424 17.8999 39.9998 17.8999C36.5756 17.8999 33.7998 20.6757 33.7998 24.0999C33.7998 27.5241 36.5756 30.2999 39.9998 30.2999Z"
              fill="white"
            />
            <path
              d="M40 59.8999C42.7614 59.8999 45 57.6613 45 54.8999C45 52.1385 42.7614 49.8999 40 49.8999C37.2386 49.8999 35 52.1385 35 54.8999C35 57.6613 37.2386 59.8999 40 59.8999Z"
              fill="#84827E"
            />
            <path
              d="M40.0003 28.0279C42.1696 28.0279 43.9283 26.2692 43.9283 24.0999C43.9283 21.9305 42.1696 20.1719 40.0003 20.1719C37.8309 20.1719 36.0723 21.9305 36.0723 24.0999C36.0723 26.2692 37.8309 28.0279 40.0003 28.0279Z"
              fill="#84827E"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_254_1450"
            x="15.8002"
            y="1.79995"
            width="51.5996"
            height="79.6001"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_254_1450"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_254_1450"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_254_1450"
            x1="29.9382"
            y1="43.4043"
            x2="48.9448"
            y2="65.2059"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_254_1450"
            x1="32.0943"
            y1="15.0676"
            x2="47.028"
            y2="32.1974"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_254_1450">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default SpeakerIcon;
